import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FileOutlineIcon from '@mui/icons-material/Description';
import MainTable from '../../../components/Table/PaginationTable.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { OutBoxColumnDefDefaultFn } from '../columns/columnDef.js';
import { useSelector, useDispatch } from 'react-redux';
import { deleteOrderById, fetchOrders, placeOrder, fetchLinkingOrders, setOrder, resetOrderState } from '../../../redux/orderSlice.js';
import { useTranslation } from 'react-i18next';
import dataJSON from "../columns/dummyData.json";
import DownloadButton from '../../../components/common components/DownloadButton.js';
import FilterPanel from '../../../components/common components/FilterPanel.js';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import DeclineModalComponent from '../../../components/Modals/DeclineModalComponent.js';
import LinkedOrdersModal from './Modals/LinkedOrderModal.js';
import ReasonModalComponent from '../../../components/Modals/ReasonModalComponent.js';
import DownloadCatelougeModal from './Modals/DownloadCatelougeModal.js';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import LoaderComp from '../../../components/common components/Loader.js';
import WarningShipmentModalComponent from '../../../components/Modals/WarningShipmentModalComponent.js';
dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');

const OrdersOutboxComponent = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetails = useSelector(state => state.auth.userDetails);

  // const { data, loading, error } = useState(''); // Assuming the state shape
  const tableData = useSelector(state => state.order.orderData) || []// console.log("****",state.order.data
  // const isFetchOrdersLoading = useSelector(state => state.order.loading.fetchOrders);
  const isFetchOrdersLoading = useSelector(state => Object.values(state.order.loading).some(status => status));
  const isError = useSelector(state => state.order.error);
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteOrderId, setDeleteOrderId] = useState('');


  
  const open = Boolean(anchorEl);
  const totalRecords = useSelector(state => state.order.paginationInfo?.totalRecords) || 0;

  const [filterCriteria, setFilterCriteria] = useState({
    search: '',
    fromDate: '',
    toDate: ''
  });
  const linkedOrderList = useSelector(state => state.order.linkingorders.data || []);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isReasonModalOpen, setIsReasonModalOpen] = useState(false);
  const [isDownloadCatModalOpen, setIsDownloadCatOpen] = useState(false);
  // const [onCancelCrieteria, setOnCancelCrieteria] = useState(null); // To store the order ID being deleted
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const [actionType, setActionType] = useState('')
  const [newOrderId, setOrderId] = useState('')
  const [reasonData, setReasonData] = useState({})

  const handleLinkOpenModal = (actionType, newOrderId) => {
    console.log('Mllll', actionType, newOrderId);
    setOrderId(newOrderId)
    setActionType(actionType)
    setLinkModalOpen(true);

  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLinkCloseModal = () => setLinkModalOpen(false);

  const handleDownloadCatOpenModal = () => {
    setIsDownloadCatOpen(true)
  }

  const handleDownloadCatCloseModal = () => {
    setIsDownloadCatOpen(false)
    setAnchorEl(null);
  }


  // const handleReasonOpenModal = () => setIsReasonModalOpen(true)
  // const handleReasonCloseModal = () => setIsReasonModalOpen(false)


  // Function to handle filter action
  const handleFilter = (criteria) => {
    const formattedCriteria = {
      search: criteria.search,
      fromDate: criteria.fromDate ? dayjs(criteria.fromDate).format('YYYY-MM-DD') : '',
      toDate: criteria.toDate ? dayjs(criteria.toDate).format('YYYY-MM-DD') : ''
    };
    setFilterCriteria(formattedCriteria);
    // Perform filtering logic based on criteria
    console.log('Filter criteria:', formattedCriteria);
    const queryParams = {
      type: 'outgoing',
      searchText: formattedCriteria.search,
      fromDate: formattedCriteria.fromDate,
      toDate: formattedCriteria.toDate,
      pageSize,
      pageNumber,
    };
    dispatch(fetchOrders(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {
    // setFilterCriteria({
    //   search: '',
    //   fromDate: '',
    //   toDate: ''
    // });
    dispatch(fetchOrders({
      type: 'outgoing',
      searchText: '',
      fromDate: '',
      toDate: '',
      pageSize, // Use state value
      pageNumber,
    }))
    console.log('Filter criteria reset');
  };

  useEffect(() => {
    console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber},`);// ${token}
    dispatch(resetOrderState())
    const queryParams = {
      type: 'outgoing',
      // searchText: filterCriteria.search?filterCriteria.search : '',  
      // fromDate:  filterCriteria && filterCriteria.fromDate ? dayjs(filterCriteria.fromDate).format('YYYY-MM-DD'): '',
      // toDate: filterCriteria && filterCriteria.toDate ? dayjs(filterCriteria.toDate).format('YYYY-MM-DD'):'',
      searchText: '',
      fromDate: '',
      toDate: '',
      pageSize, // Use state value
      pageNumber, // Use state value
      // companyKeyId: 224
    };
    dispatch(fetchOrders(queryParams));
    resetOrderState()
  }, [dispatch, pageSize, pageNumber]);
  useEffect(() => {
    console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
    dispatch(resetOrderState())
    const queryParams = {
      searchText: '',
      fromDate: '',
      toDate: '',
      pageSize, // Use state value
      pageNumber, // Use state value
    };
    dispatch(fetchLinkingOrders(queryParams));

  }, [dispatch, pageSize, pageNumber]);
  const navigateCallback = (orderId) => {
    navigate(`/details/${orderId}`); // Replace with your desired path
  };
  const editOrderFun = (orderId, actionType, orderStatus) => {
    console.log('Order status',orderStatus)
    if (orderStatus === "Place") {
      navigate(`/edit-order-place/${orderId}`, { state: { actionType: actionType, orderId: orderId } });
    }
    else {
      navigate(`/edit-order/${orderId}`, { state: { actionType: actionType, orderId: orderId } });
    }
}
const placeOrderFun = (orderId, actionType) => {
  dispatch(placeOrder({
    orderId: orderId.orderId,
    actionType: actionType
  })
  ).then(() => dispatch(fetchOrders({
    type: 'outgoing',
    searchText: '',
    fromDate: '',
    toDate: '',
    pageSize, // Use state value
    pageNumber
  })))
  console.warn("In Place", orderId, actionType)
}
const deleteOrderFun = (orderId, actionType) => {
  console.warn("In Delete", orderId, actionType)
  dispatch(deleteOrderById({ orderId: deleteOrderId }))
    .then((response) => {
      dispatch(fetchOrders({
        type: 'outgoing',
        searchText: '',
        fromDate: '',
        toDate: '',
        pageSize, // Use state value
        pageNumber
      }))
      resetOrderState()
      console.log('deleted successfully:', response);
    })
    .catch((error) => {
      console.error('Error deleting product:', error);
    });

}
const closeDeleteModal = () => {
  // setIsDeleteModalOpen(false);
};
const handleDeclineModal = (orderId, actionType) => {
  setOrderId(orderId)
  setActionType(actionType)
  // setOnCancelCrieteria(orderId);
  console.warn("In Cancel", orderId, actionType)
  setIsCancelModalOpen(true);
};
const viewReason = (reason, actionType) => {
  setReasonData(reason)
  setActionType(actionType)
  setIsReasonModalOpen(true);

  // setOnCancelCrieteria(orderId);
  console.warn("In Reason", reason, actionType)
};


const handleCreateOrderBtnClick = () => {
  navigate('/create-order'); // Navigate to create order page
};

const onPageIndexChange = (newPageIndex) => {
  setPageNumber(newPageIndex);
};

const onPageSizeChange = (newPageSize) => {
  setPageSize(newPageSize);
  setPageNumber(1); // Reset to the first page when page size changes
};
 // TO Delete row 
  const onDeleteOrderBtnClick = (orderId, actionType) => {
  setIsDeleteModalOpen(true);
  setDeleteOrderId(orderId)
};

const onDeleteModalClose = () => {
  setIsDeleteModalOpen(false)
}
// if (isFetchOrdersLoading) return <LoaderComp />
if (isError) return <div>Error: {isError}</div>;
console.log('isFetchOrdersLoading Status :::::::::::::=> ', isFetchOrdersLoading)
const columnDef = OutBoxColumnDefDefaultFn(navigateCallback, editOrderFun, deleteOrderFun, placeOrderFun, handleDeclineModal, isCancelModalOpen, closeDeleteModal, handleLinkOpenModal, viewReason, isReasonModalOpen, reasonData,onDeleteOrderBtnClick, t);

return (
  <>
    <div className="btn-box py-3">
      <div className="d-flex justify-content-between">
        <div>
          <button className="btn btn-primary greeen-btn md_btn" onClick={handleCreateOrderBtnClick}>
            <span><ControlPointOutlinedIcon /></span> {t('orderOutboxcomponents.createNew')}
          </button>
        </div>
        <div>
          <Button
            aria-controls="export-menu"
            aria-haspopup="true"
            onClick={handleClick}
            // variant="contained"
            style={{ backgroundColor: '#6AA13C' }}
            className='btn btn-primary greeen-btn md_btn m-2 h-100'
            startIcon={<FileOutlineIcon />}
          >
            Export
          </Button>
          <Menu
            id="export-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
          >
            <MenuItem onClick={handleDownloadCatOpenModal}>Order Company Catalogue</MenuItem>
            <MenuItem onClick={handleDownloadCatOpenModal}>Order Product Catalogue</MenuItem>
            <MenuItem onClick={handleClose}>  <DownloadButton
              data={tableData}
              filename='Outgoing Order List.xlsx'
              sheetname='Order List'
              forModule='Order' /></MenuItem>
          </Menu>
          {/* <DownloadButton
              data={tableData}
              filename='Outgoing Order List.xlsx'
              sheetname='Order List'
              forModule='Order' /> */}
          {/* <FilterPanel onFilter={handleFilter} onReset={handleReset} /> */}
          <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
            <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span> {t('orderOutboxcomponents.filters')}
          </button>
          {/* <button className="btn btn-primary greeen-btn md_btn">
              <span><i className="mdi mdi-file-document"></i></span>{t('btnGrpText.downloadOrders')}
            </button> */}
          {/* <button className="btn btn-primary greeen-btn md_btn" onClick={handleDownloadCatOpenModal}>Open download modal</button> */}
          {isDownloadCatModalOpen && <DownloadCatelougeModal open={open} handleClose={handleDownloadCatCloseModal} />}
        </div>
      </div>
    </div>
    {isFilterPanelOpen && <FilterPanel className='mb-3' isFromDateToDate={true} onFilter={handleFilter} onReset={handleReset} />}
    {/* {isFetchOrdersLoading ? <LoaderComp /> : */}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        // className="custom-table-class"
        recordCountText="records found"
      />
    {/* } */}
    {/* {linkModalOpen && <LinkedOrdersModal
        open={linkModalOpen}
        onClose={handleLinkCloseModal}
        actionType={actionType}
        orderId={newOrderId}
        linkedOrderList={linkedOrderList}
      />} */}

    {userDetails?.company.companyRoles !== "BR" && (linkModalOpen && <LinkedOrdersModal
      open={linkModalOpen}
      onClose={handleLinkCloseModal}
      actionType={actionType}
      orderId={newOrderId}
      linkedOrderList={linkedOrderList}
    />)}
    {/* {isReasonModalOpen && <ReasonModalComponent
       open={isReasonModalOpen}
       handleClose={handleReasonCloseModal}
       action={actionType}
       reasonData={reasonData}
    />} */}

{isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={deleteOrderFun}
        />)}
  </>
)
}

export default OrdersOutboxComponent;
